import React, { useState, useEffect } from "react";
import Wrappers from "../shared/Wrappers";
// import Header from "./Headers";
import FilterButtons from "../shared/FilterButtons";
import MyQuotesTable from "./MyQuotesTable";
import ActiveJobsTables from "./ActiveJobsTables";
import { GetAllDispatche } from "../../../services/admin/dispatche";
import Loader from "../../shared/loader";
import SharedHeaders from "../shared/SharedHeaders";
import NotFoundIcon from "../../shared/NotFoundIcon";

const DispatcheMain = () => {
  const [loading, setLoading] = useState(false);
  const [AllData, setAllData] = useState([]);
  const [SearchInputValue, setSearchInputValue] = useState("");
  const [SelectedDateCallback, setSelectedDateCallback] = useState("");
  const [CurrentPage, setCurrentPage] = useState(1);
  const [activeButton, setactiveButton] = useState(0);

  const ButtonsArray = [{ title: "My Quotes" }, { title: "Active Jobs" }];

  useEffect(() => {
    handleFetchAllDispatchs();
  }, [activeButton, SearchInputValue, SelectedDateCallback, CurrentPage]);

  const handleFetchAllDispatchs = async () => {
    const StatusType = ButtonsArray[activeButton]?.title || "";
    const Search = SearchInputValue || "";
    const Date = SelectedDateCallback || "";
    const Page = CurrentPage || 1;
    await GetAllDispatche(
      setLoading,
      setAllData,
      StatusType,
      Search,
      Date,
      Page
    );
  };

  return (
    <Wrappers>
      {loading && <Loader />}
      <SharedHeaders
        Placeholder="Search for Sender, Receiver, Order, Type"
        SearchInputValue={SearchInputValue}
        setSearchInputValue={setSearchInputValue}
        SelectedDateCallback={SelectedDateCallback}
        setSelectedDateCallback={setSelectedDateCallback}
        HasAccountType={false}
      />
      {/* <Header /> */}
      <FilterButtons
        ButtonsArray={ButtonsArray}
        activeButton={activeButton}
        setactiveButton={setactiveButton}
        setCurrentPage={setCurrentPage}
      />
      {!loading && (
        <>
          {AllData && AllData?.data && AllData?.data?.length > 0 ? (
            <>
              {activeButton === 0 && (
                <MyQuotesTable
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
              {activeButton === 1 && (
                <ActiveJobsTables
                  data={AllData?.data || []}
                  CurrentPage={CurrentPage}
                  setCurrentPage={setCurrentPage}
                  Last_page={AllData?.last_page}
                  total_pages={AllData?.total_pages}
                />
              )}
            </>
          ) : (
            !loading && <NotFoundIcon MT="20" IconWidth="10" />
          )}
        </>
      )}
    </Wrappers>
  );
};

export default DispatcheMain;
